var AppComponent = /** @class */ (function () {
    function AppComponent() {
        console.log(window.location);
        if (window.location.search.toString().indexOf('?register') >= 0) {
            this.isRegister = true;
        }
        else if (window.location.search.toString().indexOf('?existing-user') >= 0) {
            this.loginFromExternalLink = true;
        }
    }
    return AppComponent;
}());
export { AppComponent };
